import React from 'react';
import { PageShell } from './PageShell.jsx';
import { getActiveLocale, localizedHref } from './i18n/bootstrap.js';
import { stripLocale } from './i18n/index.js';
import { appUrl } from './app-origin.js';
import { USE_CASE_REVIEWED, useCaseContent, useCaseLabels } from './use-case-content.js';

export function UseCasePage({ slug }) {
  const locale = getActiveLocale();
  const key = slug || (typeof window !== 'undefined' ? stripLocale(window.location.pathname).replace(/\.html$/, '').replace(/\/$/, '').split('/')[2] : '');
  const content = useCaseContent(key, locale);
  const labels = useCaseLabels(locale);
  if (!content) return null; // Only registered static routes are published.
  const sections = ['situation', 'evidence', 'workflow', 'example', 'limits', 'questions', 'related'];
  return <PageShell currentPath="/use-cases" title={`${content.title} | ScopeWorth`} description={content.description}>
    <main className="sw-usecase-detail">
      <header className="ins-post-hero">
        <div className="ins-post-hero-bg" aria-hidden="true" />
        <div className="sw-container">
          <a className="ins-back" href={localizedHref('/use-cases')}>{labels.back}</a>
          <div className="ins-post-hero-inner">
            <h1 className="ins-post-title">{content.title}</h1>
            <p className="ins-post-deck">{content.answer}</p>
            <p className="sw-usecase-byline"><a href={localizedHref('/about')}>{labels.author}</a><span>{labels.reviewed} <time dateTime={USE_CASE_REVIEWED}>{new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${USE_CASE_REVIEWED}T00:00:00Z`))}</time></span></p>
            <a className="sw-btn sw-btn-primary" href={appUrl('/sign-up')} data-cta="use-case-hero">{labels.cta}</a>
          </div>
        </div>
      </header>
      <div className="ins-post-body sw-container">
        <article className="ins-post-main sw-usecase-prose" aria-label={content.title}>
          <section id="situation"><h2>{labels.situation}</h2><p>{content.situation}</p></section>
          <section id="evidence"><h2>{labels.evidence}</h2><ul>{content.evidence.map((item) => <li key={item}>{item}</li>)}</ul><p>{labels.availability} <a href={localizedHref('/integrations')}>{labels.integrations}</a>.</p></section>
          <section id="workflow"><h2>{labels.workflow}</h2><ol>{content.workflow.map((item) => <li key={item}>{item}</li>)}</ol></section>
          <section id="example"><h2>{labels.example}</h2><p id="example-disclosure">{labels.exampleNote}</p>
            <div className="sw-usecase-table"><table aria-describedby="example-disclosure"><thead><tr>{labels.columns.map((column) => <th scope="col" key={column}>{column}</th>)}</tr></thead><tbody>{content.rows.map(([record, conclusion]) => <tr key={record}><td>{record}</td><td>{conclusion}</td></tr>)}</tbody></table></div>
            <h3>{labels.decision}</h3><p>{content.decision}</p>
          </section>
          <section id="limits"><h2>{labels.limits}</h2><p>{content.limits}</p><p>{labels.ai} <a href={localizedHref('/pricing')}>{labels.pricing}</a>.</p></section>
          <section id="questions"><h2>{labels.questions}</h2>{content.faq.map((item) => <div key={item.q}><h3>{item.q}</h3><p>{item.a}</p></div>)}</section>
          <section id="related"><h2>{labels.related}</h2><ul>
            <li><a href={content.guide}>{labels.guide}</a></li>
            <li><a href={`/blog/${content.blog}/`}>{labels.article}</a></li>
            <li><a href={localizedHref('/integrations')}>{labels.integrations}</a></li>
            <li><a href={localizedHref('/pricing')}>{labels.pricing}</a></li>
          </ul></section>
        </article>
        <aside className="ins-post-rail"><nav className="sw-usecase-outline" aria-label={labels.back}>{sections.map((id) => <a key={id} href={`#${id}`}>{labels[id]}</a>)}</nav></aside>
      </div>
      <section className="sw-section sw-section-dark sw-section-final"><div className="sw-container"><div className="sw-final">
        <h2 className="sw-h-display">{labels.cta}</h2><p className="sw-lead sw-lead-dark">{labels.ctaLead}</p>
        <div className="sw-cta-actions"><a href={appUrl('/sign-up')} data-cta="use-case-final" className="sw-btn sw-btn-primary sw-btn-lg">{labels.cta}</a><a href={localizedHref('/pricing')} className="sw-btn sw-btn-ghost-dark sw-btn-lg">{labels.pricing}</a></div>
      </div></div></section>
    </main>
  </PageShell>;
}
